import { Layout } from "antd";
import { Content } from "antd/es/layout/layout";
import { Outlet } from "react-router-dom";
import { PageNavbar, PageFooter, PageHeader } from "./components";
import usePageLayout from "./usePageLayout";
import { ContactUsSection } from "shared/sections";

import "./styles.scss";

const PageLayout = () => {
  const { isHomePage, pathname } = usePageLayout();

  return (
    <Layout className="page-layout">
      <PageNavbar isHomePage={isHomePage}  />
      <Content className="page-content">
        {isHomePage === false && <PageHeader  href={pathname}/>}
        <Outlet />
        <ContactUsSection />
      </Content>
      <PageFooter />
    </Layout>
  );
};

export default PageLayout;
